import React from 'react'
import {Transaction} from '../../types/app-types'
import {
  formatAmount,
  formatDateMonthDayString,
  sortBy
} from '../../services/utils'
import {TransactionFlow, TransactionType} from '../../types/app-types'

interface TransactionListProps {
  transactions: Transaction[]
}

function formatType(type: TransactionType): string {
  switch (type) {
    case TransactionType.Allowance:
      return 'Refund'
    case TransactionType.Charge:
    case TransactionType.TransitoryCharge:
      return 'Charge'
    case TransactionType.Concession:
      return 'Concession'
    case TransactionType.Payment:
      return 'Payment'
    case TransactionType.Refund:
      return 'Payment Refund'
    default:
      console.warn(`Unsupported transaction type: ${type}`)
      return type
  }
}

function formatTransactionName(transaction: Transaction): string {
  switch (transaction.type) {
    case TransactionType.Payment:
      return `Payment - Placemakr`
    case TransactionType.Refund:
      return `Refund`
    default:
      return transaction.description
  }
}

const TransactionList = ({transactions}: TransactionListProps) => {
  const sortedTxs = sortBy(transactions, 'date')
  return (
    <table className="w-full table table-zebra table-compact table-fixed mt-2 border-t-2 border-gray-400">
      <tbody>
        {sortedTxs?.length ? (
          sortedTxs.map((t: Transaction) => {
            const {amount, date, flow, refIds, type} = t
            const [id] = refIds
            const formattedAmount =
              flow !== TransactionFlow.Debit
                ? `-${formatAmount(amount)}`
                : formatAmount(amount)
            return (
              <tr key={id}>
                <td className="w-2/3 sm:w-3/4">
                  <div className="text-left flex sm:flex-row flex-col truncate">
                    <div className="w-full sm:w-1/3 truncate">
                      <span className="">{formatTransactionName(t)}</span>
                    </div>
                    <div className="flex flex-row w-full sm:w-2/3">
                      <span className="text-gray-500 sm:w-1/2 sm:text-center">
                        {formatDateMonthDayString(date)}
                      </span>
                      <span className="ml-2 mr-2 sm:invisible sm:mr-0 sm:ml-0">
                        -
                      </span>
                      <span className="text-gray-500 sm:w-1/2 sm:text-center">
                        {formatType(type)}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="w-1/3 sm:w-1/4">
                  <div className="text-right truncate">
                    <span>{formattedAmount}</span>
                  </div>
                </td>
              </tr>
            )
          })
        ) : (
          <tr>
            <td colSpan={2}>No transactions</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TransactionList
